module.exports = __webpack_public_path__ + "static/media/ML_PRIMARY_VERT_2C_DBG.1c665383.svg";